<template>
  <div class="absolute fill-height events-page">

    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card flat class="no__radius pa-0 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title class="pl-0 pt-0">
            <h2>Nový výkup kovu</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows">
            <v-form v-model="create_valid" lazy-validation ref="createForm">
              <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <datepicker label="Datum" class="mb-2" :rules="true" v-model="datum"></datepicker>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <osobasearch label="Vyhledat klienta" class="mb-2" v-model="osoba_id" :rules="rulesRequired" :all="true"></osobasearch>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        label="Číslo OP"
                        v-model="cislo_op"
                        class="mx-3"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md8>
                      <productsearch label="Vyhledat produkt" class="mb-2" style="margin-left:0!important;margin-right:0!important" v-model="produkt_id" @changed="(e) => { addProdukt(e); }" clearOnSelect typ_produktu="mince_slitek"></productsearch>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <seriovecislosearch label="Vyhledat sériové číslo" class="pl-2" :prodane="true" v-model="seriove_cislo_id" @changed="(e) => { addProduktSerioveCislo(e); }" clearOnSelect></seriovecislosearch>
                    </v-flex>

                    <v-flex xs12 class="mb-4">
                      <v-data-table
                        :headers="headersCreate"
                        :items="itemsCreate"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        item-key="row_id"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                              {{ props.item.produkt.nazev }}
                            </router-link>
                          </td>
                          <td>
                            <!-- <seriovecislosearch label="Vyhledat sériové číslo" class="pl-2" v-if="props.item.produkt.vyzadovat_seriove_cislo && props.item.hledat_seriove_cislo" :produkt="props.item.produkt.id" :prodane="true" @change="(e) => { props.item.poznamka = props.item.produkt.seriove_cislo != null && props.item.produkt.seriove_cislo.length > 0 && e == null; }" v-model="props.item.produkt.seriove_cislo"></seriovecislosearch>
                            <span v-else>{{ props.item.seriove_cislo }}</span> -->
                            <v-text-field
                              label="Sériové číslo"
                              v-model="props.item.produkt.seriove_cislo"
                              :rules="rulesRequired"
                              v-if="props.item.produkt.vyzadovat_seriove_cislo"
                              @blur="overitSerioveCislo(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              label="Výkupní cena"
                              :rules="rulesRequired"
                              suffix="Kč"
                              v-model="props.item.vykupni_cena"
                              @input="prepocitatCenu()"
                            ></v-text-field>
                          </td>
                          <td>
                            <span v-if="props.item.poznamka" class="red--text">Nebylo nakoupeno u CC</span>
                            <span v-else>--</span>
                          </td>
                          <td class="text-xs-right">
                            <v-btn dark depressed icon flat fab color="red" class="ma-0" @click="polozka=props.item;dialogRemove=true">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <template slot="footer">
                          <tr>
                            <td>Celkem:</td>
                            <td colspan="4" class="text-xs-right">
                              {{celkova_castka | formatMoney}} Kč
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>

                    <v-flex xs12>
                      <v-layout row wrap align-center>
                        <v-flex xs12>
                          <p class="bold error--text mt-0 mb-0" :class="{'mb-3':$vuetify.breakpoint.xs}">Zaúčtování ve Flexibee je třeba udělat ručně.</p>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </div>
          <v-card-actions class="pa-0 mt-3">
            <v-spacer></v-spacer>
            <v-btn dark depressed color="green" :loading="saving" @click="save">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
        <v-card class="pa-0">
          <v-card-title class="pt-0 px-0">
            <h2>Smazat výkup kovu</h2>
          </v-card-title>
          <v-card-text class="pt-0 px-0 pb-2">
            <p>Opravdu chcete smazat produkt <strong>{{polozka.produkt.nazev}}</strong> z&nbsp;výkup kovu?</p>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="itemsCreate.splice(itemsCreate.indexOf(polozka), 1); dialogRemove = false; prepocitatCenu();"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogRemove=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetailRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogDetailRemove"
      >
        <v-card class="pa-0">
          <v-card-title class="pt-0 px-0">
            <h2>Smazat výkup kovu</h2>
          </v-card-title>
          <v-card-text class="pt-0 px-0 pb-2">
            <p>Opravdu chcete smazat produkt <strong>{{polozka.produkt.nazev}}</strong> z&nbsp;výkup kovu?</p>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="smazatVykupProdukt();" :loading="removing"><v-icon class="mr-2">delete</v-icon> Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDetailRemove=false" v-if="!removing">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
      <v-card flat class="no__radius pa-0 gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <v-card-title class="pl-0 pt-0">
          <h2>Detail výkupu kovu</h2>
        </v-card-title>
        <div class="gui-flex gui-flex-rows">
          <v-form v-model="create_valid" lazy-validation ref="createForm">
            <v-card color="grey lighten-4 elevation-0" class="pa-0" :class="{'pt-3 pl-3 pr-3 pb-1' : $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <datepicker label="Datum" class="mb-2" :rules="true" v-model="detailItem.datum" :disabled="true"></datepicker>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <osobasearch label="Klient" class="mb-2" v-model="detailItem.osoba_id" :rules="rulesRequired" :disabled="true"></osobasearch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Číslo OP"
                      v-model="detailItem.cislo_op"
                      :disabled="true"
                      class="mx-3"
                    ></v-text-field>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 md8>
                    <productsearch label="Produkt" class="mb-2" style="margin-left:0!important;margin-right:0!important" v-model="produkt_id" @changed="(e) => { addProdukt(e); }" clearOnSelect typ_produktu="mince_slitek"></productsearch>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <seriovecislosearch label="Sériové číslo" class="pl-2" :prodane="true" v-model="seriove_cislo_id" @changed="(e) => { addProduktSerioveCislo(e); }" clearOnSelect></seriovecislosearch>
                  </v-flex> -->

                  <v-flex xs12 class="mb-4">
                    <v-data-table
                      :headers="headersDetail"
                      :items="detailItem.polozky"
                      :pagination.sync="pagination"
                      :total-items="pagination.totalItems"
                      :rows-per-page-items="[25, 50, 100, 200]"
                      item-key="row_id"
                    >
                      <template slot="items" slot-scope="props">
                        <td>
                          <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                            {{ props.item.produkt.nazev }}
                          </router-link>
                        </td>
                        <td>
                          <!-- <seriovecislosearch label="Vyhledat sériové číslo" class="pl-2" v-if="props.item.produkt.vyzadovat_seriove_cislo && props.item.hledat_seriove_cislo" :produkt="props.item.produkt.id" :prodane="true" @change="(e) => { props.item.poznamka = props.item.produkt.seriove_cislo != null && props.item.produkt.seriove_cislo.length > 0 && e == null; }" v-model="props.item.produkt.seriove_cislo"></seriovecislosearch>
                          <span v-else>{{ props.item.seriove_cislo }}</span> -->
                          <v-text-field
                            label="Sériové číslo"
                            v-model="props.item.seriove_cislo"
                            v-if="props.item.produkt.vyzadovat_seriove_cislo"
                            @blur="overitSerioveCislo(props.item)"
                            readonly
                          ></v-text-field>
                        </td>
                        <td>
                          {{ props.item.cena | formatMoney }} Kč
                        </td>
                        <td class="text-xs-right">
                          <v-btn dark depressed icon flat fab color="red" class="ma-0" @click="polozka=props.item;dialogDetailRemove=true">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </td>
                      </template>
                      <template slot="footer">
                        <tr>
                          <td>Celkem:</td>
                          <td colspan="3" class="text-xs-right">
                            {{detailItem.celkova_castka | formatMoney}} Kč
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>

                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-flex shrink>
                        <a :href="api_url + 'vykup-kovu/' + detailItem.id + '/pdf'" target="_blank"><v-btn color="primary" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout smlouvu</v-btn></a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-form>
        </div>
        <v-card-actions class="pa-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs6 sm6>
                <h3>Výkup kovu</h3>
              </v-flex>
              <v-flex xs6 sm6 class="text-xs-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" outline @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Výkup
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.datum | formatSimpleDate }}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby_razeni }}
                    </router-link>
                  </td>
                  <td>{{ props.item.celkova_castka | formatMoney }} Kč</td>
                  <td class="text-center">
                    <a :href="api_url + 'vykup-kovu/' + props.item.id + '/pdf'" target="_blank"><v-btn color="primary" flat depressed class="ma-0"><v-icon small class="mr-2">picture_as_pdf</v-icon>Stáhnout smlouvu</v-btn></a>
                  </td>
                  <td class="text-center">
                    <v-btn color="primary" @click="editItemClick(props.item)" class="elevation-0">
                    <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      counter: 0,
      loadingTable: false,
      dialogCreate: false,
      dialogDetail: false,
      dialogRemove: false,
      dialogDetailRemove: false,
      editMode: false,
      saveCreate: false,
      headersCreate: [
        { text: 'Název produktu', value: 'nazev_produktu' },
        { text: 'Sériové číslo', value: 'seriove_cislo' },
        { text: 'Výkupní cena', value: 'vykupni_cena' },
        { text: 'Poznámka', value: 'poznamka', sortable: false },
        { text: 'Smazat', value: null, sortable: false, align: 'right' },
      ],
      headersDetail: [
        { text: 'Název produktu', value: 'nazev_produktu' },
        { text: 'Sériové číslo', value: 'seriove_cislo' },
        { text: 'Výkupní cena', value: 'vykupni_cena' },
        { text: 'Smazat', value: null, sortable: false, align: 'right' },
      ],
      headersEdit: [
        { text: 'Název produktu', value: 'nazev_produktu' },
        { text: 'Sériové číslo', value: 'seriove_cislo' },
        { text: 'Výkupní cena', value: 'vykupni_cena' },
        { text: 'Smazat', value: null, sortable: false, align: 'right' },
      ],
      itemsCreate: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Datum', value: 'datum' },
        { text: 'Klient', value: 'klient' },
        { text: 'Částka', value: 'castka' },
        { text: 'Smlouva PDF', value: null, sortable: false, align: 'center' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      osoba_id: null,
      items: [],
      newItem: null,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "id",
        totalItems: 0
      },
      create_valid: true,
      datum: null,
      produkt_id: null,
      produkt: null,
      polozka: null,
      vykup_kovu: null,
      rulesRequired: [ (v) => !!v || "Pole je vyžadováno" ],
      saving: false,
      removing: false,
      seriove_cislo_id: null,
      datum: null,
      celkova_castka: 0,
      cislo_op: null
    }
  },
  watch: {
    pagination: {
      deep: true,
      handler (v) {
        this.load();
      }
    },
  },
  computed: {
    api_url () {
      return window.api.$api_url;
    }
  },
  mounted () {
    this.load();
  },
  methods: {
    load: function(f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("vykup-kovu/search", {
        pagination: this.pagination,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.datum = parseInt(new Date().getTime() / 1000);
      this.osoba_id = null;
      this.cislo_op = null;
      this.itemsCreate = [];
      this.celkova_castka = 0;
      this.dialogCreate = true;
    },
    addProdukt (e) {
      if (e == null)
        return;
      window.API.get("produkty/" + e.id + "/ceny").then(function(body) {
        var v = {};
        v.id = null;
        v.row_id = window.th.makeid();
        v.poznamka = false;
        v.hledat_seriove_cislo = true;
        v.produkt = window.th.copy(e);
        v.produkt.seriove_cislo = null;
        this.itemsCreate.push(v);
        this.produkt_id = null;
        var cena = body.filterOne((e) => {
          return e.mena.id == 1;
        });
        v.vykupni_cena = cena.vykupni_cena;
        this.prepocitatCenu();
      }.bind(this)).catch(function(err) {
      }.bind(this));
    },
    prepocitatCenu () {
      var celkova_castka = 0;
      for (var i = 0; i < this.itemsCreate.length; i++) {
        celkova_castka += !isNaN(this.itemsCreate[i].vykupni_cena) ? parseInt(this.itemsCreate[i].vykupni_cena) : 0;
      }
      this.celkova_castka = celkova_castka;
    },
    addProduktSerioveCislo (e) {
      if (e == null)
        return;
      window.API.get("produkty/" + e.produkt.id + "/ceny").then(function(body) {
        var v = {};
        v.id = null;
        v.row_id = window.th.makeid();
        v.poznamka = false;
        v.hledat_seriove_cislo = true;
        v.produkt = window.th.copy(e.produkt);
        v.produkt.seriove_cislo = e.seriove_cislo;
        this.itemsCreate.push(v);
        this.seriove_cislo_id = null;
        var cena = body.filterOne((e) => {
          return e.mena.id == 1;
        });
        v.vykupni_cena = cena.vykupni_cena;
        this.prepocitatCenu();
      }.bind(this)).catch(function(err) {
      }.bind(this));
    },
    overitSerioveCislo (e) {
      window.api.post("sklady/seriova-cisla/search", {
        s: e.produkt.seriove_cislo,
        produkt: e.produkt.id,
        prodane: true,
        cele: true
      }).then(function($r) {
        e.poznamka = $r.data.length == 0;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    save () {
      if (this.$refs.createForm.validate() && this.itemsCreate.length > 0) {
        this.saving = true;
        window.API.post("vykup-kovu", {
          datum: this.datum,
          klient: this.osoba_id,
          produkty: this.itemsCreate.map((e) => {
            return {
              id: e.produkt.id,
              seriove_cislo: e.produkt.seriove_cislo,
              cena: e.vykupni_cena
            };
          }),
          cislo_op: this.cislo_op
        }).then((b) => {
          if (b.created) {
            this.saving = false;
            this.dialogCreate = false;
            this.load();
          }
          else {
            this.saving = false;
          }
        }).catch((e) => {
          this.saving = false;
          console.log(e);
        })
      }
    },
    editItemClick (e) {
      window.API.get("vykup-kovu/" + e.id).then(function(body) {
        this.detailItem = body;
        this.dialogDetail = true;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    smazatVykupProdukt () {
      this.removing = true;
      window.API.delete("vykup-kovu/" + this.detailItem.id + "/polozka/" + this.polozka.id).then(function(body) {
        if (body.deleted) {
          this.dialogDetailRemove = false;
          this.editItemClick(this.detailItem);
          var celkova_castka = 0;
          for (var i = 0; i < this.detailItem.polozky.length; i++) {
            celkova_castka += !isNaN(this.itemsCreate[i].vykupni_cena) ? parseInt(this.itemsCreate[i].vykupni_cena) : 0;
          }
          this.detailItem.celkova_castka = celkova_castka;
          this.load();
        }
        this.removing = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.removing = false;
      }.bind(this));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/VykupProdej/VykupKovu.vue